import { DefaultTableTypes } from '../components/table-switch/table-switch.component';

export const defaultTableTypes: DefaultTableTypes = {
  reservation: [
    {
      name: 'table',
      value: 'table',
      url: 'assets/svg/reservation-table.svg',
      whiteUrl: 'assets/svg/reservation-table-white.svg',
      backgroundColor: '#1AB99F',
    },
    {
      name: 'calendar',
      value: 'calendar',
      url: 'assets/svg/calendar-dark.svg',
      whiteUrl: 'assets/svg/calendar-white.svg',
      backgroundColor: '#DEFFF3',
    },
  ],
  campaign: [
    {
      name: 'campaignType',
      value: 'campaignType',
      url: 'assets/svg/campaign-type.svg',
      whiteUrl: 'assets/svg/campaign-type-white.svg',
      backgroundColor: '#1AB99F',
    },
    {
      name: 'campaignDetails',
      value: 'campaignDetails',
      url: 'assets/svg/campaign-detail.svg',
      whiteUrl: 'assets/svg/campaign-detail-white.svg',
      backgroundColor: '#DEFFF3',
    },
  ],
  outlet: [
    {
      name: 'In-Room',
      value: 'inRoom',
      url: 'assets/svg/room-dine-in-grey.svg',
      whiteUrl: 'assets/svg/room-dine-in.svg',
      backgroundColor: '#DEFFF3',
    },
    {
      name: 'Card',
      value: 'card',
      url: 'assets/svg/card-view-black.svg',
      whiteUrl: 'assets/svg/card-view-white.svg',
      backgroundColor: '#1AB99F',
    },
    {
      name: 'Table',
      value: 'table',
      url: 'assets/svg/table-view-black.svg',
      whiteUrl: 'assets/svg/table-view-white.svg',
      backgroundColor: '#DEFFF3',
    },
  ],
};
